/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import GUI                         from 'services/gui';
  import ApplicationState            from 'store/application';
  import ClickMixin                  from 'mixins/click';
  import { getCatalogLayerById }     from 'utils/getCatalogLayerById';
  import { XHR }                     from 'utils/XHR';

  const __vue_script__ = {
    name: "catalog-layer-legend",
    props: {
      legendplace: {
        type: String
      },
      layer: {
        type: Object
      }
    },
    data() {
      return {

        /**
         * Whether to show loading bar while changing style categories
         *
         * @since 3.8.0
         */
        loading: false,

        /**
         * Array of categories
         */
        categories: [],

        /**
         * Holds a reference to current layer style (active category)
         *
         * @since 3.8.0
         */
        currentstyle: this.layer.styles.find(style => true === style.current).name,

      }
    },
    mixins: [ClickMixin],
    computed: {

      /**
       * @returns {boolean} whether to display total number of features for current layer
       *
       * @since 3.8.0
       */
      showfeaturecount() {
        return undefined !== this.layer.featurecount;
      },

      /**
       * @returns {boolean} whether is a WMS layer
       */
      externallegend() {
        return ('wms' === this.layer.source.type);
      },

      /**
       * @returns {boolean} whether layer has legend to show
       */
      legend() {
        return this.layer.legend;
      },

      /**
       * @returns {boolean} whether if needed to show legend
       */
      show() {
        return (
          this.layer.expanded &&
          this.layer.visible &&
          ('toc' === this.legendplace || 'tab' === this.legendplace && this.layer.categories)
        );
      },

    },

    methods: {

      /**
       * @since v3.8
       */
      onCategoryClick() {
        this.handleClick({
          '1': () => { /** @TODO this.selectCategory() */ console.info('TODO: select category (single click)'); },
          '2': () => { /** @TODO this.zoomToCategory() */ console.info('TODO: zoom to category (double click)'); }
        }, this);
      },

      /**
       * Show category contextual menu
       * 
       * @fires showmenucategory
       * 
       * @since v3.8
       */
      showCategoryMenu() {
        this.$emit('showmenucategory');
      },
  
      getWmsSourceLayerLegendUrl() {
        return this.getProjectLayer().getLegendUrl({
          ...(window.initConfig.layout || {}).legend,
          width:  16,
          height: 16,
        });
      },

      getProjectLayer() {
        return getCatalogLayerById(this.layer.id);
      },

      isDisabled(index) {
        return this.categories[index].disabled;
      },

      showHideLayerCategory(index) {
        this.categories[index].checked = !this.categories[index].checked;
        //emit chang layer on map to refresh tiles
        this.getProjectLayer().change();
        
        if ('tab' === this.legendplace) {
          this.layer.legend.change = true;
          
        } else if (this.categories[index].checked && this.mapReady) {
          this.setLayerCategories(false);
        }

      },

      setError() {
        this.legend.error   = true;
        this.legend.loading = false;
      },

      async urlLoaded() {
        this.legend.loading = false;
      },

      /**
       * Handle changing style of layer legend
       *
       * @since 3.8.0
       */
      async onChangeLayerLegendStyle(options = {}) {
        this.loading = true;

        if (this.externallegend) {
          return;
        }

        try {
          await this.setLayerCategories(true);
          this.currentstyle = options.style;                                // Set current style.
          if (this.dynamic) {    
            await this.setLayerCategories(false);                           // toggle categories.
          }
        } catch(e) {
          console.warn('Error while changing layer style', e)
        }

        this.loading = false;
      },

      /**
       * @param { boolean } all true = no bbox no filter (just all referred to)
       */
      async setLayerCategories(all = false) {
        try {
          const projectLayer = this.getProjectLayer();
          const categories   = projectLayer.getCategories();

          if (all && categories) { // check if exist current layer categories
            this.categories = categories;
          } else {
            const { nodes = [] } = await XHR.get({
              url: projectLayer.getLegendUrl(
                window.initConfig.layout?.legend,
                {
                  categories: true,
                  format:     'application/json', // request format (icon and label of each category)
                  all,
                }
              )
            });
            if (all) { // case of all categories
              this._setAllLayerCategories(nodes);
            } else {
              this._updateLayerCategories(nodes, categories);
            }
          }
        } catch(e) {
          console.warn(e);
          this.setError();
        }
      },

      /**
       * @since 3.8.0
       */
      _setAllLayerCategories(nodes) {
        const projectLayer = this.getProjectLayer();

        const categories = [];
        nodes.forEach(({ icon, title, ruleKey, checked, symbols = []}) => {
          if (icon) {
            // just one category is set (take care of `checked` and `ruleKey`).
            categories.push({ icon, title, ruleKey, checked, disabled: false });
          } else {
            // there are more that one category (`symbols` array is set).
            symbols.forEach(symbol => {
              symbol._checked = symbol.checked;
              symbol.disabled = false;
              categories.push(symbol);
            });
          }
        });
        projectLayer.setCategories(categories);
        this.categories = categories;
      },

      /**
       * @since 3.8.0
       */
      _updateLayerCategories(nodes = [], categories = []) {
        this.getProjectLayer().setCategories(categories);

        this.categories = categories;

        // case to update current categories
        if (nodes.length > 0) {
          nodes.forEach(({ icon, title, symbols = [] }) => {
            if (icon) {
              symbols = [{ icon, title }];
            }
            categories.forEach(c  => {
              const findSymbol  = symbols.find(s => s.icon === c.icon && s.title === c.title);
              const disabled    = undefined === c.checked  || c.checked;
              c.disabled        = disabled && undefined === findSymbol;
            });
          })
        } else {
          categories.forEach(c => c.disabled = (undefined === c.checked) || c.checked);
        }
      },

      /**
       * @since 3.8.0
       */
      async onChangeMapLegendParams() {
        this.mapReady = true;
        if (
          this.layer.visible &&
          false === this.externallegend &&
          ('toc' === this.legendplace || this.layer.categories)
        ) {
          this.setLayerCategories(false);
        }
      },

      /**
       * @returns {Promise<void>}
       *
       * @listens map~change-map-legend-params
       *
       * @since 3.8.0
       */
      async runInitLayerVisibleAction() {
        await this.setLayerCategories(true);
        if (this.dynamic) {
          await this.setLayerCategories(false);
          GUI.getService('map').on('change-map-legend-params', this.onChangeMapLegendParams);
        }
        this.initialize = true;
      },

    },

    watch: {

      /**
       * Only when visible show categories layer. In case of dynamic legend check
       *
       * @param {boolean} visible
       */
      async 'layer.visible'(visible) {
        // check if layer is enabled to get legend and if is visible
        const enabled = visible && false === this.externallegend;
        // initialize if it is the first time that is visible.
        if (enabled && false === this.initialize) {
          await this.runInitLayerVisibleAction();
        }
        // otherwise show categories base on if is dynamic legend or not
        if (enabled && false !== this.initialize) {
          await this.setLayerCategories(!this.dynamic);
        }
      }

    },

    async created() {

      /**
       * Used to check if layer and its legend categories are initialized
       * That means register all events at first time the layer is visible
       * without do any server request
       *
       * @type {boolean}
       *
       * @since 3.8.0
       */
      this.initialize = false;

      /**
       * @FIXME the following comment seems wrong (isn't `this.dynamic` a `boolean` variable?)
       *
       * Store legend url icons based on the current style of layer.
       * It uses to cache all symbols of a style without get a new request to server
       *
       * @type {{}}
       */
      this.dynamic = ApplicationState.project.state.context_base_legend;

      this.mapReady = false;

      // listen to layer change style event
      this.getProjectLayer().onafter('change', this.onChangeLayerLegendStyle);

      // Get all legend graphics of a layer when start
      // need to exclude wms source
      if (false === this.externallegend && true === this.layer.visible) {
        await this.runInitLayerVisibleAction();
      }

    },

    beforeDestroy() {
      //remove change event on legend
      this.getProjectLayer().un('change', this.onChangeLayerLegendStyle);
    },

  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"layer-legend",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[(_vm.legend)?_c('bar-loader',{attrs:{"loading":_vm.legend.loading}}):_vm._e(),_vm._v(" "),(_vm.externallegend)?_c('figure',[_c('img',{attrs:{"src":_vm.getWmsSourceLayerLegendUrl()}})]):_c('figure',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.loading),expression:"loading"}]},[_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_vm._l((_vm.categories),function(category,index){return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(category.disabled),expression:"category.disabled"}],staticStyle:{"display":"flex","align-items":"center","width":"100%"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showCategoryMenu.apply(null, arguments)}}},[(category.ruleKey)?_c('span',{class:_vm.$fa(category.checked ? 'check': 'uncheck'),staticStyle:{"padding-right":"3px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showHideLayerCategory(index)}}}):_vm._e(),_vm._v(" "),(('toc' === _vm.legendplace))?_c('img',{attrs:{"src":category.icon && ("data:image/png;base64," + (category.icon))},on:{"error":function($event){return _vm.setError()},"load":function($event){return _vm.urlLoaded()}}}):_vm._e(),_vm._v(" "),(('tab' === _vm.legendplace && category.ruleKey) || ('toc' === _vm.legendplace))?_c('span',{staticClass:"g3w-long-text",staticStyle:{"padding-left":"3px"},on:{"click":function($event){$event.stopPropagation();return _vm.onCategoryClick.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(category.title))]),_vm._v(" "),(_vm.showfeaturecount && undefined !== category.ruleKey)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n          ["+_vm._s(_vm.layer.featurecount[category.ruleKey])+"]\n        ")]):_vm._e()]):_vm._e()])})],2)],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3a05dc99_0", { source: ".layer-legend[data-v-3a05dc99]{padding-left:36px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-3a05dc99"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CatalogLayerLegend.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__